import axios from "../axios"

const miscApi = {
	getAllVideos(data) {
		return axios({
			url: `/gzeua/TrainVideoCompany/ManagerQuery`,
			method: "post",
			data
		})
	},
	getCompanyVideos(data) {
		return axios({
			url: `/gzeua/TrainVideoCompany/Query`,
			method: "post",
			data
		})
	},
	
	deleteMenu(id) {
		return axios({
			url: `/gzeua/Menu/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	

}
export default miscApi